"use client";

import { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { faqTranslations } from "@/lib/pagesTranslations";

interface Props {
  locale: "pt" | "en";
}

export default function FaqAccordion({ locale }: Props) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) =>
    setOpenIndex(openIndex === index ? null : index);

  const faqs = faqTranslations[locale] ?? faqTranslations["pt"];

  return (
    <div className="max-w-3xl mx-auto px-4 pb-10 pt-8">
      {faqs.map((item, index) => (
        <div
          key={index}
          className="border-b border-gray-200 py-4 flex flex-col justify-between items-center cursor-pointer"
        >
          <div
            onClick={() => toggle(index)}
            className="flex justify-between items-center w-full"
          >
            <h3 className="text-lg font-semibold text-[#1B475D]">
              {item.question}
            </h3>
            <span className="text-[#1B475D]">
              {openIndex === index ? <FaMinus /> : <FaPlus />}
            </span>
          </div>
          {openIndex === index && (
            <p className="mt-4 text-medium text-[#1B475D]/80 leading-relaxed w-full">
              {item.answer}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
